import { userService } from "../api/user-auth";

const state = {
  plants: [],
  new_plant: null,
};

const getters = {
  // eslint-disable-next-line no-unused-vars
  plants: (state, getters) => {
    return state.plants;
  },
};

const actions = {
  loadPlants({ commit }, plants) {
    commit("loadPlants", plants);
  },
  getPlants({ dispatch, commit }) {
    userService.getJson("plant/list").then(
      response => {
        if (response.ok) {
          commit("loadPlants", response.data);
        } else {
          commit("clear");
          dispatch("alert/error", response.message, { root: true });
        }
      },
      error => {
        commit("clear");
        dispatch("alert/error", error, { root: true });
      },
    );
  },
  apiSavePlant({ dispatch, commit }, plant) {
    userService.put("plant/" + plant.id, plant).then(
      response => {
        if (response.ok) {
          commit("updatePlant", response.data);
        } else {
          dispatch("alert/error", response.message, { root: true });
        }
      },
      error => {
        dispatch("alert/error", error, { root: true });
      },
    );
  },
  apiCreatePlant({ dispatch, commit }, plant) {
    userService.post("plant/" + plant.id, plant).then(
      response => {
        if (response.ok) {
          commit("addPlant", response.data);
          dispatch("sites/addPlant", response.data, { root: true });
        } else {
          dispatch("alert/error", response.message, { root: true });
        }
      },
      error => {
        dispatch("alert/error", error, { root: true });
      },
    );
  },
  addPlant({ commit }, plant) {
    commit("addPlant", plant);
  },
};

const mutations = {
  addPlant(state, plant) {
    state.plants.push(plant);
    state.new_plant = plant;
  },
  updatePlant(state, plant) {
    var index = state.plants.findIndex(v => v.id == plant.id);
    state.plants[index] = plant;
  },
  loadPlants(state, plants) {
    state.plants = plants;
  },
  clear(state) {
    state.plants = [];
  },
};

export const plants = {
  namespaced: true,
  getters,
  state,
  actions,
  mutations,
};
